<template>
  <div style="height: 100%;">
    <div class="advance-search-modal">
      <div class="flex-space-between">
        <div>Multiple Selection Pq Legal</div>
      </div>

      <div class="horizontal mt10 text-bold">
        <div class="column10">
          <!-- <input type="checkbox" v-model="selectAll" /> -->
          <i
            class="fa-solid fa-square"
            style="color: #0075FF;"
            v-if="
              choosedVendor.length < legal_doc.length &&
                choosedVendor.length > 0
            "
            @click="setSelectAll(true)"
          ></i>
          <i
            class="fa-regular fa-square"
            @click="setSelectAll(true)"
            v-if="!selectAll && choosedVendor.length == 0"
          ></i>
          <i
            class="fa-solid fa-square-check"
            style="color: #0075FF;"
            @click="setSelectAll(false)"
            v-if="selectAll && choosedVendor.length == legal_doc.length"
          ></i>
        </div>
        <div class="column10">ID</div>
        <div class="column40">Nama Vendor</div>
        <div class="column30">Status</div>
        <div class="column10">Dokumen Detail</div>
      </div>

      <div style="width: 100%;height: 60%;overflow: auto;">
        <div v-for="(item, index) in legal_doc">
          <div class="horizontal mt10">
            <div class="column10">
              <input type="checkbox" :value="item" v-model="choosedVendor" />
            </div>
            <div class="column10">{{ item.isupplier_code }}</div>
            <div class="column40">
              {{ item.nama_vendor }}, {{ item.alias_profile }}
            </div>
            <div class="column30">
              <span v-html="checkExpired(item.docs)"></span>
            </div>
            <div class="column10 text-center">
              <span
                ><i
                  class="fas fa-bars cursor-pointer"
                  @click="setShowDetail(index)"
                ></i
              ></span>
            </div>
          </div>
          <div class="horizontal">
            <div class="column10"></div>
            <div
              class="column80"
              v-if="isShowDetail == index"
              style="border: 1px solid gray; padding: 10px"
            >
              <div
                class="horizontal"
                :style="`color: black; font-size: 12px`"
                v-for="(list, j) in item.docs"
                :key="j"
              >
                <div class="horizontal" style="width: 100%;padding: 10px">
                  <div class="column40">
                    {{ list.name }}
                  </div>
                  <div class="column10">
                    -
                  </div>
                  <div class="column30">Tanggal Berakhir: {{ list.date }}</div>
                  <div
                    :class="
                      `column20 ${
                        list.status == 'Expired' ? 'text-red' : 'legend-satisfy'
                      }`
                    "
                  >
                    {{ list.status }} ({{ list.available }} Hari)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="resetFilter()">RESET</div>
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="runSearch()">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  data() {
    return {
      isShowDetail: null,
      choosedVendor: [],
      selectAll: false,
    }
  },
  computed: {
    legal_doc() {
      const data = this.$store.state.notifStore.legal_doc

      return data
    },
  },
  watch: {
    // selectAll(value) {
    //   if (value) {
    //     this.choosedVendor = [...this.legal_doc]
    //   } else {
    //     this.choosedVendor = []
    //   }
    // },
  },
  methods: {
    setSelectAll(value) {
      this.selectAll = value
      if (value) {
        this.choosedVendor = [...this.legal_doc]
      } else {
        this.choosedVendor = []
      }
    },
    setShowDetail(value) {
      if (this.isShowDetail == null || this.isShowDetail != value) {
        this.isShowDetail = value
      } else {
        this.isShowDetail = null
      }
    },
    runSearch() {
      this.$store.dispatch('notifStore/createMassPq', this.choosedVendor)
    },
    closeModal() {
      this.$store.commit('notifStore/UPDATE_DATA', {
        name: 'multi_modal',
        value: false,
      })
    },
    resetFilter() {
      this.choosedVendor = []
      this.selectAll = false
    },
  },
}
</script>
